import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { ToastService } from '../toast/toast.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let isauthenticated = this.authService.isAuthenticated();

    if (!isauthenticated()) {
      return true;
    } else {
      this.router.navigate(['/']);
      this.toastService.add(
        `Você já está logado!`,
        30000,
        'warning'
      );
      return false;
    }
  }
}
